// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2fRGB","rootSuccess":"CompleteLink_rootSuccess__3a-8C","rootFailure":"CompleteLink_rootFailure__ZtWMl","isDisabled":"CompleteLink_isDisabled__3H6Ug"};